import * as React from 'react'
import type { SVGProps } from 'react'
function SvgLaternen219420003357(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 141.31 233.86"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <line x1={113.06} x2={28.2} y1={130.72} y2={130.72} />
      <path d="m70.63,198.22h-20.59c-1.7,0-3.28-.9-4.16-2.36l-3.78-6.35c-1.27-2.12-1.76-4.61-1.47-7.06,2.3-19.11-2.69-38.44-14.05-54.09l-9.83-13.53c-9.23-11.87-14.75-26.86-14.75-43.16C2,33.2,32.74,2,70.66,2s68.66,31.2,68.66,69.66c0,16.3-5.52,31.29-14.75,43.16l-9.83,13.53c-11.37,15.65-16.35,34.98-14.05,54.09.3,2.45-.2,4.94-1.47,7.06l-3.78,6.35c-.87,1.46-2.45,2.36-4.16,2.36h-20.59" />
      <line x1={41.11} x2={100.2} y1={183.92} y2={183.92} />
      <path d="m90.98,199.13v19.09c0,7.53-8.44,13.63-18.85,13.63h-4c-10.41,0-18.85-6.1-18.85-13.63v-19.09" />
      <line x1={50.34} x2={89.93} y1={212.08} y2={212.08} />
      <path d="m71.51,56.64c-11.29,14.21-9.84,29.58-.73,36.04,4.56,3.23,10.62,3.42,16.72,1.13,10.22-3.84,17.12-13.47,17.88-24.36.2-2.91.39-6.04.48-8.82.52-15.32,8.71-29.81,8.71-29.81,0,0-32.81,12.93-43.06,25.83Z" />
      <path d="m70.04,129.12c.38-9.66,1.01-20.99,1.52-24.14,2.54-15.67,9.46-30.58,20.33-42.84l.14-.16" />
      <path d="m56.12,86.11c8.81,4.75,11.41,12.85,8.19,18.1-1.61,2.62-4.64,4.04-8.23,4.2-6.01.28-11.6-3.11-14.35-8.46-.73-1.43-1.51-2.98-2.16-4.37-3.59-7.65-10.88-13.21-10.88-13.21,0,0,19.43-.57,27.43,3.74Z" />
      <path d="m63.5,105.3c1.49,1.72,1.88,3.39,3.1,5.31,1.56,2.46,2.9,5.07,3.99,7.8" />
    </svg>
  )
}
export default SvgLaternen219420003357
